var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs-items',{attrs:{"value":_vm.advanced,"touchless":""}},[_c('v-tab-item',[_c('roles',{on:{"toggle":_vm.handleToggle}})],1),_c('v-tab-item',[_c('roles-advanced',{on:{"toggle":_vm.handleToggle}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }